import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface MaterialsProps {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterMaterials: React.FC<MaterialsProps> = ({ blockPath, tComponents, filterEnabled }) => (
  <Container gap={0} fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.MaterialsTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterMaterials`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput path={`${blockPath}.materials`} label={tComponents('DMFilterSearch.InputLabelMaterials')} />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.materialsDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.MaterialsDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterMaterials;
